module.exports = __webpack_public_path__ + "media/ko_kr_s2_HoSook.9f69b31d.oga";